const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const HealEvent = require('../../events/HealEvent');
const { logError } = require('../../logger');

const HealingPrayer = function(battleState) {
  this.handle = 'healing_prayer';
  this.ranged = true;
  this.magical = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return;
    }

    setTimeout(() => {
      if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
        return;
      }

      try {
        const healEvent = new HealEvent(battleState, actor, BattleCalc.getEquippedAbility(actor,'healing_prayer').potency);
        healEvent.execute(victim);

        var result = { healEvent };
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim? victim.uid : null;
        result.allPieces = battleState.allPieces;
        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'HealingPrayer',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.getCooldown(actor) * 0.27 + 0.42);
  };
};
module.exports = HealingPrayer;
